import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { useCallback, useRef } from "react";
import { USP_LIST } from "@/pages/quiz/base/components/header/common";

import "swiper/css";
import "swiper/css/navigation";

interface IProps {
  t10_2?: boolean;
}

const ABTest10USPMobile = ({ t10_2 }: IProps) => {
  const sliderRef = useRef<SwiperRef>(null);

  const handleNavigation = useCallback(
    (isNext: boolean) => () => {
      if (!sliderRef.current) {
        return;
      }

      if (isNext) {
        sliderRef.current.swiper.slideNext();
      } else {
        sliderRef.current.swiper.slidePrev();
      }
    },
    []
  );

  return (
    <div className="w-full bg-dark-purple-2 relative md:hidden">
      <Swiper
        modules={[Navigation, Autoplay]}
        slidesPerView={1}
        loop
        navigation={{
          prevEl: ".usp-prev",
          nextEl: ".usp-next",
        }}
        autoplay={
          t10_2
            ? {
                delay: 5000,
                disableOnInteraction: false,
              }
            : undefined
        }
      >
        {USP_LIST.map((item, index) => (
          <SwiperSlide key={index} className="">
            <div className="flex items-center justify-center gap-3 min-h-14">
              {item.icon}
              <p className="text-white whitespace-pre-wrap font-semibold text-xs leading-[15px]">
                {item.title}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <button
        onClick={handleNavigation(false)}
        className="usp-prev absolute p-1 left-4 top-1/2 -translate-y-1/2 z-10 text-white"
      >
        <FaChevronLeft />
      </button>
      <button
        onClick={handleNavigation(true)}
        className="usp-next absolute p-1 right-4 top-1/2 -translate-y-1/2 z-10 text-white"
      >
        <FaChevronRight />
      </button>
    </div>
  );
};

export { ABTest10USPMobile };
